<template>
    <el-button @click="view" type="primary" size="small" >
        <i class="fa el-icon-edit"></i>
    </el-button>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props: {
            text: {},
            row: {},
        },
        methods: {
            view() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'photo-change',
                })
                location.href = '/#/photo/change/' + this.row.id
            }
        },
        mounted() {
            this.$nextTick(function () {
                // console.log("TEXT", this.text)
                // console.log("row", this.row)
            });
        }
    }
</script>

<style scoped>

</style>
